import { status } from 'constants/general';

export const initialCommonState = {
  context: '',
  configurations: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
};

export const initialGeneralState = {
  testGeneral: '',
};

export const initialAccountManagementState = {
  userAuthenticationInfo: {
    status: status.SHOULD_CALL_API,
    details: [],
  },
  loginInfo: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
};

export const initialMembersState = {
  membersList: {
    details: {},
    status: status.SHOULD_CALL_API,
    addUserStatus: status.SHOULD_CALL_API,
    snackBarMessage: '',
  },
  member: {
    details: {},
    status: status.SHOULD_CALL_API,
    blockingStatus: status.SHOULD_CALL_API,
    updatingPointsStatus: status.SHOULD_CALL_API,
    snackBarMessage: '',
  },
  memberTransactionsList: {
    All: {
      status: status.SHOULD_CALL_API,
      details: {},
    },
    Approved: {
      status: status.SHOULD_CALL_API,
      details: {},
    },
    Deducted: {
      status: status.SHOULD_CALL_API,
      details: {},
    },
  },
  memberTransactionsFilteredList: {
    data: [],
  },
};
